<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchFun">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="规则名称">
              <a-input
                placeholder="请输入规则名称"
                v-model="queryParam.name"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="触发方式">
              <a-select v-model="queryParam.type" placeholder="请选择">
                <a-select-option value="1">事件</a-select-option>
                <a-select-option value="2">定时</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span
              style="float: left;overflow: hidden;"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchFun" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="resetFun"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator" style="border-top: 5px">
      <a-button @click="handleAdd" type="primary" icon="plus"
        >新增规则</a-button
      >
      <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel">
            <a-icon type="delete"/>
            删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down"/>
        </a-button>
      </a-dropdown> -->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;<a
          style="font-weight: 600"
          >{{ selectedRowKeys.length }}</a
        >项&nbsp;&nbsp;
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        bordered
        size="middle"
        :columns="columns"
        :dataSource="dataList"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="goDetails(record)">查看</a>

          <a-divider type="vertical" />
          <a @click="goEdit(record)">编辑</a>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <number-card-modal
      ref="modalForm"
      @ok="modalFormOk"
      @saveData="saveData"
    ></number-card-modal>
  </a-card>
</template>

<script>
import moment from 'moment';
import numberCardModal from './numberCardModal';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { constants } from 'zlib';
export default {
  inject: ['reload'],
  name: 'numberCard',
  mixins: [JeecgListMixin],
  components: {
    numberCardModal
  },
  data() {
    return {
      queryParam: {},
      columns: [
        {
          title: '规则名称',
          align: 'center',
          key: '1',
          dataIndex: 'ruleName'
        },
        {
          title: '触发方式',
          align: 'center',
          dataIndex: 'ruleType',
          key: '2'
        },
        {
          title: '事件名称',
          align: 'center',
          dataIndex: 'eventName',
          key: '3'
        },
        {
          title: '发送时间Cron',
          align: 'center',
          dataIndex: 'sendTime',
          key: 'sendTime'
        },
        {
          title: '发送对象',
          align: 'center',
          dataIndex: 'sendstr',
          key: '4'
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: '5',
          scopedSlots: {
            customRender: 'action'
          },
          align: 'center'
        }
      ],
      dataList: [],
      url: {
        list:
          process.env.VUE_APP_CMS_WECHATCUSTOMER +
          '/wechatwork/customerService/data',
        delete:
          process.env.VUE_APP_CMS_WECHATCUSTOMER +
          '/wechatwork/market/userDelete',
        deleteBatch:
          process.env.VUE_APP_WECHATCUSTOMER +
          '/wechatwork/market/userDeleteBatch'
      }
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      this.dataList = [
        {
          ruleName: '规则1',
          ruleType: '定时',
          eventName: '规则1事件', //事件名称
          sendTime: '0 0 6 1-2 * ? *',
          sendstr: '杨羊、丁健',
          key: '0-1'
        },
        {
          ruleName: '规则2',
          ruleType: '事件',
          eventName: '规则2事件', //事件名称
          sendTime: '0 0 0/1 1-2 * ? *',
          sendstr: '丁健',
          key: '0-2'
        },
        {
          ruleName: '规则3',
          ruleType: '定时',
          eventName: '规则3事件', //事件名称
          sendTime: '0 0 0/1 1-2 1-2 ? *',
          sendstr: '王康岚 ',
          key: '0-3'
        }
      ];
    },
    searchFun() {},
    resetFun() {
      this.queryParam.name = '';
      this.queryParam.type = '';
    },
    saveData(data) {
      console.log(data);
      this.dataList.push(data);
      return false;
      if (JSON.stringify(data) == '{}') {
        return;
      }

      let arr = [
        {
          key: '1',
          value: '基金从业资格证'
        },
        {
          key: '1',
          value: '证券从业资格证'
        }
      ];
      let list = [];
      data.certificate.forEach(item => {
        let obj = arr.find(e => e.key == item);
        list.push(obj.value);
      });

      let info = {
        img: data.portrait,
        product: '000006,008542',
        create_time: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        wechat: data.qrCode,
        cert: list.join(','),
        dept: null,
        title: data.duties,
        point: '没事别操作！',
        relation: '2362efd4235643b1bd984dded8789006',
        create_by: '0000',
        update_time: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        phone: null,
        name: data.name,
        id: this.getNum(),
        update_by: '6d66cd54d1e8411c84d8768e514b3349',
        knowledge: null
      };
      this.dataList.push(info);
      console.log('this.dataList', this.dataList);
      console.log('data', data);
    },
    getNum() {
      var chars = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z'
      ];
      var nums = '';
      for (var i = 0; i < 32; i++) {
        var id = parseInt(Math.random() * 61);
        nums += chars[id];
      }
      return nums;
    }
  }
};
</script>
<style scoped>
/deep/ .drawer-bootom-button {
  position: unset !important;
}
@import '~@assets/less/common.less';
</style>
